export const APP = {
  DEFAULT_TITLE: 'DeepBox',
}
